module.exports = __webpack_public_path__ + "img/xinye.5dc2f048.png";